<script lang="ts" setup>
import { computed } from "vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { typography } from "@/Modules/App/Models/Styles/Typos";

export interface TcTagProps {
  size?: "large" | "small";
  link?: string;
  background?: colorTag;
  color?: colorTag;
  text?: typography;
}

const props = withDefaults(defineProps<TcTagProps>(), {
  size: "large",
  background: "content-low",
  color: "content-high",
});

const colorClass = computed((): string => `color-${props.color}`);
const backgroundClass = computed((): string => `bg-${props.background}`);
const textClass = computed((): string => `typography-${props.text}`);
</script>
<template>
  <div
    class="tag"
    :class="{ [`tag--${props.size}`]: true, [backgroundClass]: true, [colorClass]: true, [textClass]: true }"
  >
    <a v-if="props.link" class="tag__link" :href="link" :class="{ [colorClass]: true }">
      <slot />
    </a>

    <slot v-else />
  </div>
</template>

<style lang="scss" scoped>
.tag {
  @include radius(s);

  display: flex;
  align-items: center;
  justify-content: center;
  height: auto;
  min-width: 35px;
  width: fit-content;

  &__link {
    text-decoration: none;
  }

  &__link:visited {
    text-decoration: none;
  }

  &--small {
    @include text.general(low, m);
    @include sp.padding(x, 2);
    @include sp.padding(y, 1);
  }

  &--large {
    @include text.general(high, l);
    @include sp.padding(y, 2);
    @include sp.padding(x, 4);
  }
}
</style>
